import { LoadingController } from '@ionic/angular';

export class LoaderUtils {

  static loader: HTMLIonLoadingElement;
  static loadingCtrl: LoadingController;

  static init(loadingCtrl: LoadingController) {
    this.loadingCtrl = loadingCtrl;
  }

  static async create(message: string = null) {
    if (!this.loadingCtrl) {
      throw new Error('LoaderUtils not initialized');
    }
    this.loader = await this.loadingCtrl.create({
      message: message || 'Chargement...',
      spinner: 'dots',
    });
  }

  static async present() {
    if (!this.loader) {
      await this.create();
    }
    return this.loader?.present();
  }

  static async dismiss() {
    const loader = this.loader;
    this.loader = null;
    return loader?.dismiss();
  }

  static async createAndPresent(message: string = null) {
    if (this.loader) {
      return;
    }
    await this.create(message);
    return this.present();
  }

}
